import React from "react";
import { store } from "../../../redux/storeConfig/store";
import { history } from "../../../app/AppRouter";
import { setStartStaffSessionModalOpen } from "../../../redux/actions/staffSession/staffSessionAction";

export const StepButton = (props) => {
  return (
    <>
      <div className="action-wrapper blk-padding-y">
        <div className="action-inner-block">
          <div className="action-btn-block d-flex">
            <button
              className="btn btn-medium btn-transparent"
              onClick={() => {
                store.dispatch(setStartStaffSessionModalOpen(false));
              }}
            >
              Cancel
            </button>
            <button value="Next" className="btn btn-medium">
              Start Session
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
